// Botões "fale com um consultor"
function transferWhatsappClick() {
    function clickOnRdButton() {
        return document.querySelector('.rdstation-popup-js-floating-button').click()
    }

    const buttons = Array.from(document.getElementsByClassName('transferClickToWhatsappRD'));

    if(buttons) {
        buttons.map(item => { item.addEventListener('click', clickOnRdButton) });
    }
}

window.addEventListener('load', transferWhatsappClick);
